import React from 'react';

import { Skeleton } from 'src/component/ds/ui/skeleton';


/** The headline figure and the wasted/total chip beneath it. */
export function HeadlineSkeleton () {
  return (
    <div className='ds-flex ds-flex-col ds-gap-3' data-testid='potential-energy-savings-headline-skeleton'>
      <Skeleton className='ds-h-12 ds-w-[166px]' />
      <Skeleton className='ds-h-6 ds-w-[125px]' />
    </div>
  );
}

/** The chart plot area. */
export function ChartSkeleton () {
  return (
    <Skeleton
      className='ds-h-[153px] ds-w-full'
      data-testid='potential-energy-savings-chart-skeleton'
    />
  );
}
